import { TollsInfo } from 'common/utils/Route';

export const getTollLength = (tollSections: TollsInfo['tollSections']) =>
  tollSections.reduce((totalLength, { length }) => {
    return totalLength + length;
  }, 0);
